export class CoachmarkInfoI18n {
  static messages: { [lang: string]: { [key: string]: string } } = {
    es: {},
    en: {},
    pt: {}
  };
}
